import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setBillingAddress } from "../../store/orderEntitySlice";
import { numValidate } from "../../../shared/helpers/numberValidate";

const PhoneNumber = () => {
  const dispatch = useDispatch();
  const { phone_number } = useSelector(
    (state) => state?.orderEntity?.order_billing_addresses[0]
  );
  console.log("phone_number", phone_number);
  return (
    <>
      <Form.Label>Phone</Form.Label>
      <Form.Control
        name="phone_number"
        value={phone_number}
        onKeyPress={(event) => numValidate(event)}
        maxLength={10}
        type="text"
        onChange={(e) => {
          let data = {
            field: "phone_number",
            value: e.target.value,
          };
          dispatch(setBillingAddress(data));
        }}
      />
    </>
  );
};

export default PhoneNumber;
